/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Страницата не е намерена",
  "ComingSoon": "Очаквайте скоро",
  "YesanPersonalFinance": "Yesan, лични финанси",
  "Yesan": "Yesan",
  "PersonalFinance": "Лични финанси",
  "YesanDownload": "Yesan Изтегляне",
  "ThisWebsiteUsesCookies": "Използваме \"бисквитки\", за да събираме и анализираме информация за представянето и използването на нашия сайт и да предоставяме функции на социалните медии. Продължавайки, вие се съгласявате с нашите",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Станете финансово свободни",
  "inStepsAndActions": "в 8 стъпки и 3 действия.",
  "TrackPlanAnalyze": "Проследете. Планирайте. Анализирайте.",
  "FTrack": "1. Проследяване",
  "FPlan": "2. Планирайте",
  "FAnalyze": "3. Анализирайте",
  "Features": "Функции",
  "FeaturesSubHeading": "Чисто начинаещи, вече финансово грамотни, това е приложението, от което се нуждаете, за да станете финансово свободни.",
  "ManageAccounts": "Управление на сметките",
  "CashLiquidFixedAssetsLiabilities": "Парични средства, ликвидни средства, дълготрайни активи и пасиви.",
  "TrackTransactions": "Проследяване на транзакциите",
  "IncomesExpensesTransferInvestments": "Приходи, разходи, прехвърляне, инвестиции.",
  "ImportExport": "Импортиране / експортиране",
  "YourDataAlwaysAccessible": "Вашите данни са винаги достъпни.",
  "PlanYourFreedom": "Планирайте свободата си",
  "StepsAwayFromFI": "На 8 стъпки от финансовата независимост.",
  "BudgetsAndGoals": "Бюджети и цели",
  "CheckYourProgressAndAchieve": "Проверявайте напредъка си и постигайте финансовите си цели.",
  "DashboardAndAnalytics": "Информационно табло и анализи",
  "ReviewLearnOptimizeWith": "Преглеждайте, учете, оптимизирайте с диаграми, прозрения и инструменти.",
  "Security": "Сигурност",
  "MilitaryGradeEncryption": "Криптиране от военен клас, поддръжка на биометрия, данни, съхранявани на вашите устройства.",
  "OfflineMode": "Офлайн режим",
  "YourDataAlwaysAccessibleAndModif": "Вашите данни са винаги достъпни и могат да се променят.",
  "Track": "Проследяване",
  "Income": "Доходи",
  "Expense": "Разходи",
  "Transfer": "Прехвърляне на",
  "transactionsAndManageAccounts": "транзакции и управление на различни сметки:",
  "checkings": "Проверка",
  "savings": "Спестовни",
  "realEstate": "Недвижими имоти",
  "stocks": "Фондови пазари",
  "bonds": "Облигации",
  "crypto": "Крипто",
  "notes": "Банкноти, пари в брой Портфейл",
  "envelopes": "Пликове",
  "privateEquity": "Частен капитал",
  "metal": "Метал",
  "retirement": "Пенсиониране",
  "lifeInsurance": "Животозастраховане",
  "intellectualProperty": "Интелектуална собственост",
  "otherLiquidAsset": "Други ликвидни активи",
  "otherFixedAsset": "Други дълготрайни активи",
  "mortgage": "Ипотека",
  "loan": "Потребителски кредит",
  "creditCard": "Кредитна карта",
  "otherLiability": "Други пасиви",
  "AccountsManagement": "Управление на сметки",
  "MultipleAccountsTypesAndGrouping": "Множество видове сметки и групиране",
  "LinkAccounts": "Свързване на сметки от вашите институции (налично само в някои държави)",
  "SmartAccounts": "Интелигентни сметки",
  "AddEditDeleteTransactions": "Добавяне / редактиране / изтриване на транзакции",
  "TickVerifiedTransactions": "Отбелязване на проверени транзакции",
  "CategorizeTransactions": "Категоризиране на транзакциите",
  "TagTransactions": "Маркирайте транзакциите",
  "TrackKakeiboType": "Проследяване на типа Kakeibo",
  "TrackInvestments": "Проследяване на инвестициите (налично само в някои държави)",
  "ImportFromCSVFile": "Импортирайте изцяло или поетапно транзакции от CSV файл",
  "ExportToCSVFile": "Експортиране на транзакции в CSV файл",
  "stepsTowardsFIPlanBudgetingReachGoals": "План \"8 стъпки към финансова независимост\", подробно бюджетиране, по-бързо постигане на финансовите ви цели.",
  "levelsTowardsFI": "8 стъпки към финансова независимост",
  "EstablishBudgetsPer": "Създаване на бюджети за",
  "account": "сметка",
  "accountType": "тип сметка",
  "KakeiboType": "Тип на сметката Kakeibo",
  "category": "категория",
  "tag": "таг",
  "label": "етикет",
  "TrackBudgetsPerFrequency": "Проследяване на бюджети по честота",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Създайте цели за разходи, баланс, паричен поток, действия",
  "TrackGoalsProgress": "Проследяване на напредъка на целите",
  "ReviewLearnOptimizeWithReportsCharts": "Преглеждайте, учете, оптимизирайте с помощта на отчети, диаграми, тенденции, прозрения, инструменти.",
  "Dashboard": "Информационно табло",
  "FSNetWorth": "Финансови отчети: Нетна стойност",
  "FSPnL": "Финансови отчети: Отчет за приходите и разходите / Печалба и загуба",
  "FSBalanceSheetAssetsLiabilities": "Финансови отчети: Баланс, активи, пасиви",
  "FSCashFlow": "Финансови отчети: Отчет за паричните потоци, дебит и кредит, потоци",
  "FSFlows": "Финансови отчети: Потоци",
  "FSRatios": "Финансови отчети: Съотношения",
  "TrendsMonthEnd": "Тенденции в края на месеца: Приходи и разходи, паричен поток",
  "TrendsPerformance": "Тенденции в изпълнението: Годишни, месечни, годишни",
  "IncomeTrendsPer": "Тенденции на приходите на",
  "SpendingTrendsPer": "Тенденции на разходите за",
  "RecurringItemsIE": "Повтарящи се елементи: Приходи и разходи",
  "DebtProgressTrends": "Тенденции в развитието на дълга",
  "KakeiboMTDReviewTrends": "Kakeibo: Преглед на MTD, последен месец, тенденции",
  "FIWCLE": "Финансова независимост: Стенна диаграма, разходи по Life Energy",
  "DebtPaydownSnowballAvalanche": "Изплащане на дълга: Снежна топка, лавина",
  "FullyCustomizableAnalyticsRange": "Напълно персонализируем времеви диапазон на анализите",
  "ContactUs": "Свържете се с нас",
  "Privacy": "Поверителност",
  "Terms": "Условия",
  "About": "За",
  "IAgreeToThe": "Съгласен съм с",
  "AndThe": "и",
  "PrivacyPolicy": "Политиката за поверителност",
  "TermsOfUse": "Условия за ползване",
  "DigitalSoftwareExperienceTagline": "Дигитален софтуерен опит за съвременния свят",
  "DigitalExperience": "Дигитален опит",
  "SoftwareForTheModernWorld": "Софтуер за съвременния свят",
  "MobileApplications": "Мобилни приложения",
  "forConnectedAndOfflineHumans": "за свързани и офлайн хора",
  "CloudSaaS": "Облачен SaaS",
  "ResponsiveAndWebServices": "Респонсив и уеб услуги",
  "PersonalFinanceServices": "Услуги в областта на личните финанси",
  "YS_p1": "Yesan е динамична софтуерна компания, специализирана в разработването на авангардни мобилни приложения, пригодени за потребителите. С отлично разбиране на променящите се нужди и предпочитания на днешните технически грамотни потребители Yesan се е посветила на създаването на интуитивни, ангажиращи и богати на функции мобилни изживявания, които обогатяват живота на потребителите.",
  "YS_p2": "В основата на мисията на Yesan е непрестанният ангажимент към иновациите и творчеството, като всеки продукт е щателно изработен, за да осигури безпроблемна функционалност и изключително потребителско изживяване.",
  "PersonalFinanceApplication": "Приложение за лични финанси",
  "YPF_p1": "Yesan, Personal Finance е модерно мобилно приложение за лични финанси, предназначено да даде на потребителите възможност да разполагат с всеобхватни инструменти за управление на финансите, които са удобно достъпни на върха на пръстите им. С елегантен и интуитивен интерфейс Yesan, Personal Finance предлага цялостен подход към управлението на финансите, като обслужва потребители с всички нива на финансова грамотност.",
  "YPF_p2": "Ключовите функции включват проследяване на бюджета, категоризиране на разходите и наблюдение на транзакциите в реално време, което позволява на потребителите да придобият представа за навиците си на харчене без усилие. Приложението също така предлага персонализирани опции за бюджетиране, което позволява на потребителите да си поставят финансови цели и да проследяват напредъка си във времето.",
  "YPF_p3": "Освен това Yesan, Personal Finance дава приоритет на сигурността, като използва най-съвременни протоколи за криптиране, за да защити чувствителната финансова информация на потребителите. С мерките за сигурност на банково ниво потребителите могат уверено да свързват сметките си и да синхронизират транзакциите, без да нарушават неприкосновеността на личния живот.",
  "YPF_p4": "Yesan, Personal Finance отива отвъд основното бюджетиране, като предлага задълбочени анализи и персонализирани препоръки за оптимизиране на финансовите решения. Независимо дали става въпрос за идентифициране на потенциални възможности за спестяване, наблюдение на инвестиционни портфейли или управление на стратегии за погасяване на дългове, приложението предоставя персонализирани прозрения, за да помогне на потребителите да постигнат финансовите си цели.",
  "Discover": "Открийте",
  "Firstname": "Име",
  "Lastname": "Фамилия",
  "Company":"Компания",
  "Subject": "Тема",
  "Email": "Имейл",
  "Message": "Съобщение",
  "ThankYouForContactingUs": "Благодарим ви, че се свързахте с нас",
  "ValidFirstnameRequired": "Изисква се валидно първо име.",
  "ValidLastnameRequired": "Изисква се валидно фамилно име.",
  "ValidEmailAddressRequired": "Моля, въведете валиден имейл адрес.",
  "ValidSubjectRequired": "Моля, изберете валидна тема.",
  "ValidMessageRequired": "Моля, въведете валидно съобщение.",
  "UnableToSendTheFormPleaseRetryLater": "Невъзможно е да изпратите формуляра, моля, опитайте отново по-късно.",
  "Information": "Информация",
  "Sales":"Продажби",
  "Support": "Поддръжка",
  "Press": "Натиснете",
  "Partnership": "Партньорство",
  "Other": "Други",
  "Blog":"Блог",

  "Accept":"Приемане на",
  "Decline":"Отказ",

  "WorklogCalendar":"Календар на работния дневник за Jira",

  "DirectlyAccessibleInProjectApps":"Пряк достъп в приложенията на проекта",
  "VisualizeWhereYouSpentYourTime":"Визуализирайте къде сте прекарали времето си",
  "AllYourWorklogsInACalendar":"Всички ваши работни бележки в календар",
  "MonthSummary":"Обобщение на месеца",
  "CheckIfYouForgotToLogTime":"Проверете дали не сте забравили да регистрирате времето си.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Директен достъп до въпросите и актуализиране на времето",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Щракнете върху елемента от работния дневник, за да получите директен достъп до въпросите и да редактирате проследеното време",
  "AlsoAvailableInDarkMode":"Наличен и в тъмен режим",
  "DirectlyLogWorkOnTheCalendarVisually":"Вписвайте директно работата в календара визуално",
  "ClickOnTheCalendarToCreateNewWorklog":"Кликнете върху календара, за да създадете нов работен дневник",

  "AppsForAtlassian":"Приложения за Atlassian",
  "YCL_p1":"Визуализирайте всичките си работни бележки в календар с изгледи за месец, седмица, работна седмица, ден.",
  "YCL_p2":"Регистрирайте работата директно от календара, като визуално избирате времевия интервал.",
  "YCL_p3":"Идентифицирайте, ако сте забравили да проследите времето за вашите работни листове.",
  "YCL_p4":"Наличен на вашия език: Английски (Великобритания), английски (САЩ), китайски (опростен), китайски (традиционен), чешки, датски, холандски, естонски, фински, френски, немски, унгарски, исландски, италиански, японски, корейски, норвежки, полски, португалски (Бразилия), португалски (Португалия), руски, испански, шведски, турски.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Финансово портфолио за Jira",
  "BringRealFinancialPortfolio":"Въведете истинско управление на финансовото портфолио в Jira. Проследявайте бюджети, капиталови и оперативни разходи, както и разходите по проектите на едно място.",
  "YFPAboutQ":"Колко наистина ни струват нашите проекти в Jira?",
  "YFPAbout":"Финансово портфолио за Jira\nФинансовите ръководители и PMO се мъчат да отговорят на един прост въпрос:\nКолко наистина ни струват нашите Jira проекти?\nJira проследява работата.\nФинансовият отдел проследява бюджетите.\nТова приложение най-накрая свързва двете.\n\nФинансовото портфолио превръща Jira в лека платформа за PPM + финансово планиране — без да са необходими скъпи корпоративни инструменти.",
  "YFPPorfolioQ":"Бюджети и проследяване на портфейли",
  "YFPPorfolioP":"Създавайте портфейли, обхващащи множество Jira проекти, и дефинирайте: бюджетна сума, валута, период, включени проекти, екипи. Проследявайте автоматично действителните разходи, докато работата се извършва в Jira.",
  "YFPPorfolioListQ":"Портфолиа",
  "YFPPorfolioListP":"Създавайте финансови портфолиа, които комбинират множество Jira проекти, и вижте незабавно: бюджет срещу действителни разходи, изразходване на средствата по проекта в реално време, разбивка на капиталови и оперативни разходи, разходи на проблем и проект, финансови отчети за експортиране. Всичко това се захранва директно от работните дневници на Jira.",
  "CostQ":"Автоматично изчисляване на разходите",
  "CostP":"Превърнете проследяването на времето в реални финансови данни. Приложението: чете работните дневници в Jira, прилага почасови тарифи, изчислява реалните разходи по проектите ежедневно. Без таблици. Без ръчна работа.",
  "RatesQ":"Тарифи",
  "RatesP":"Задайте почасова тарифа за проект, екип или глобално",
  "ReportQ":"Финансови отчети в CSV",
  "ReportP":"Експортирайте финансови данни за портфолиото за секунди. Идеално за: Финансови екипи, отчети на финансовия директор, планиране на бюджета, подкрепа при одит",
  "SettingsQ":"Класификация CapEx срещу OpEx",
  "SettingsP":"Подкрепа на счетоводните и одиторските изисквания. Класифицирайте работата в: Капитализирано развитие (CapEx), Оперативна работа (OpEx). Генерирайте отчети, готови за експортиране, подходящи за финансовите екипи."
};

export const documents = {
};
